import {createTheme} from '@material-ui/core/styles';
import {createTheme as muiCreateTheme} from "@mui/material/styles";
import './Theme.css';

const font = "'Inter', system-ui, -apple-system, sans-serif";

// Material UI palette parsing requires concrete color values; component CSS still uses brand tokens.
const muiBrand500 = 'rgb(22, 136, 240)';
const muiSuccess = 'rgb(23, 166, 115)';
const muiDanger = 'rgb(217, 74, 58)';
const muiInk900 = 'rgb(23, 25, 28)';
const muiInk500 = 'rgb(115, 123, 134)';
const muiPaper = 'rgb(255, 255, 255)';

export const blue = muiBrand500,
    successIconColor = muiSuccess,
    errorIconColor = muiDanger;
const white = muiPaper;

export const theme = createTheme({
    palette: {
        common: {
            blue: `${blue}`,
            white: `${white}`,
        },
        primary: {
            main: `${blue}`
        },
        secondary: {
            main: `${white}`
        }
    },
    typography: {
        fontFamily: font,
        tab: {
            fontweight: 700,
            color: "var(--brand-500)",
            fontFamily: font,
            fontSize: '1.1rem',
            textTransform: "none"
        },
        h2: {
            fontFamily: font,
            fontWeight: 700,
            fontSize: '2.5rem',
            color: `${blue}`
        },
        button: {
            textTransform: 'none'
        }
    }
});

export const SUCCESS_COLOR = 'var(--success)';

export const themeNew = muiCreateTheme({
    palette: {
        text: {
            primary: muiInk900,
            secondary: muiInk500
        },
        primary: {
            main: muiBrand500,
        },
        success: {
            main: muiSuccess
        },
        error: {
            main: muiDanger
        }
    },
    typography: {
        fontFamily: font,
        button: {
            textTransform: 'none'
        },
    },
    components: {
        MuiTableSortLabel: {
            styleOverrides: {
                root: {
                    fontFamily: 'inherit',
                    fontWeight: '800',
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                asterisk: {
                    color: "var(--danger)"
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                color: {
                    secondary: {
                        color: 'var(--brand-500)'
                    }
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                standardSuccess: {
                    color: 'var(--success)',
                    border: `1px solid var(--success)`
                },
                standardInfo: ({}) => {
                    return {
                        borderStyle: "solid",
                        borderWidth: '1px'
                    }
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    borderTop: 'none'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: ({theme}) => {
                    return {
                        // '&: disabled': {
                        //     color: theme.palette.error.contrastText,
                        //     backgroundColor: theme.palette.error.light,
                        //     opacity: .6
                        // }
                    }
                },
                containedPrimary: {
                    '&:hover': {
                        color: 'var(--paper)'
                    }
                }
            },
            outlined: {}
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    '&:disabled': {
                        opacity: .6,
                        cursor: 'default',
                        pointerEvents: 'auto'
                    }
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    fontSize: 16,
                    fontWeight: 400,
                    borderBottom: '1px solid var(--line)',
                    paddingLeft: '1rem',
                    align: 'left',
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    fontWeight: 600
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    border: `1px solid`,
                    paddingTop: '8px'
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    border: '1px solid var(--line)'
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: white
                }
            }
        }
    }
});
